import { environment } from 'src/environments/environment';

export function buildAllowedOrigins(): string[] {
  const rawUrls = [
    environment.identity_url,
    environment.identity_europe_url,
    environment.tracking_url,
    environment.products_url,
    environment.marketplace_url,
    environment.cafler_backoffice_back_url,
    environment.cafler_vehicles_url,
    environment.copec_data_url,
    environment.WIDGET_BASE_URL,
    environment.BASE_URL,
  ];

  const origins: string[] = [];
  rawUrls.forEach((value) => {
    if (!value) return;
    try {
      const origin = new URL(value).origin;
      if (!origins.includes(origin)) {
        origins.push(origin);
      }
    } catch {
      // ignore invalid URLs
    }
  });

  return origins;
}

export function isAllowedOrigin(url: string, allowedOrigins: ReadonlyArray<string>): boolean {
  if (url.startsWith('assets/')) return false;

  if (url.startsWith('http://') || url.startsWith('https://')) {
    try {
      const origin = new URL(url).origin;
      return allowedOrigins.includes(origin);
    } catch {
      return false;
    }
  }

  return true;
}
